import type { ReactNode } from "react";

/** Rail with time and actions for one message: beside the bubble, or below it in the reading layout. */
export function MessageHoverMetadata({
  side,
  pinned = false,
  placement = "beside",
  children,
}: {
  side: "start" | "end";
  pinned?: boolean;
  /** "beside" floats next to a bubble; "below" sits in the flow under a reading-layout message. */
  placement?: "beside" | "below";
  children: ReactNode;
}) {
  // Touch shows the rail in-flow below the bubble; hover-capable pointers reveal it beside the bubble on demand.
  const reveal = pinned
    ? "pointer-events-auto opacity-100"
    : "pointer-events-auto opacity-100 [@media(hover:hover)_and_(pointer:fine)]:pointer-events-none [@media(hover:hover)_and_(pointer:fine)]:opacity-0 [@media(hover:hover)_and_(pointer:fine)]:group-hover/message:pointer-events-auto [@media(hover:hover)_and_(pointer:fine)]:group-hover/message:opacity-100 [@media(hover:hover)_and_(pointer:fine)]:focus-within:pointer-events-auto [@media(hover:hover)_and_(pointer:fine)]:focus-within:opacity-100";

  if (placement === "below") {
    // Reading layout: the row keeps its height so revealing it never shifts the text.
    return (
      <div
        data-testid="message-hover-rail"
        data-placement="below"
        className={`relative z-10 mt-1 flex w-full basis-full items-center transition-opacity ${reveal} ${
          side === "end" ? "justify-start -ms-1.5" : "justify-end -me-1.5"
        }`}
      >
        {children}
      </div>
    );
  }

  return (
    <div
      data-testid="message-hover-rail"
      className={`absolute top-1/2 z-10 flex -translate-y-1/2 items-center transition-opacity ${reveal} ${
        side === "end" ? "start-full ms-1" : "end-full me-1"
      } [@media(hover:none)]:static [@media(hover:none)]:mt-1 [@media(hover:none)]:w-full [@media(hover:none)]:translate-y-0 ${
        side === "end"
          ? "[@media(hover:none)]:ms-0 [@media(hover:none)]:justify-start"
          : "[@media(hover:none)]:me-0 [@media(hover:none)]:justify-end"
      }`}
    >
      {children}
    </div>
  );
}
